/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type PatchContractProposalOtherBodyInvestmentToolType =
  (typeof PatchContractProposalOtherBodyInvestmentToolType)[keyof typeof PatchContractProposalOtherBodyInvestmentToolType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchContractProposalOtherBodyInvestmentToolType = {
  other: "other",
} as const;
